import { render, staticRenderFns } from "./WaitFor.vue?vue&type=template&id=73a554b8&scoped=true&"
import script from "./WaitFor.vue?vue&type=script&lang=js&"
export * from "./WaitFor.vue?vue&type=script&lang=js&"
import style0 from "./WaitFor.vue?vue&type=style&index=0&id=73a554b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a554b8",
  null
  
)

export default component.exports